import { render, staticRenderFns } from "./shipping_retention_offer.vue?vue&type=template&id=7fe5694f&scoped=true&"
import script from "./shipping_retention_offer.vue?vue&type=script&lang=js&"
export * from "./shipping_retention_offer.vue?vue&type=script&lang=js&"
import style0 from "./shipping_retention_offer.vue?vue&type=style&index=0&id=7fe5694f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe5694f",
  null
  
)

export default component.exports